import React from 'react';

import { Container, Action } from './styled';
import { useDateTimePicker } from '../..';

export const DateTimeActions = () => {
  const { onCancel, onSubmit, selectedValue, t } = useDateTimePicker();

  return (
    <Container>
      <Action onClick={onCancel} type="button">
        {t('Cancel')}
      </Action>
      <Action onClick={() => onSubmit && onSubmit(selectedValue)} type="button">
        {t('Ok')}
      </Action>
    </Container>
  );
};
